import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { supabase } from '../lib/supabase';

const AuthCallback: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const type = searchParams.get('type');

    const { data: sub } = supabase.auth.onAuthStateChange((event) => {
      if (event === 'PASSWORD_RECOVERY' || (type === 'recovery' && (event === 'SIGNED_IN' || event === 'INITIAL_SESSION'))) {
        navigate('/reset-password', { replace: true });
      } else if (event === 'SIGNED_IN' || event === 'INITIAL_SESSION') {
        navigate('/dashboard', { replace: true });
      }
    });

    return () => sub.subscription.unsubscribe();
  }, [navigate, searchParams]);

  return (
    <div className="loading">
      <div className="spinner"></div>
    </div>
  );
};

export default AuthCallback;
